export const convertHexToRgba = (hex, alpha) => {
  if (!hex || !hex.startsWith('#')) {
    return `rgba(255, 102, 51, ${alpha})`
  }

  const value = hex.slice(1)
  const bigint = Number.parseInt(value.length === 3
    ? value.split('').map(char => char + char).join('')
    : value, 16)

  const r = (bigint >> 16) & 255
  const g = (bigint >> 8) & 255
  const b = bigint & 255

  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}
